var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllergicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Allergic"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.82692 9.25V0.75C9.82692 0.608333 9.87491 0.489583 9.97087 0.39375C10.0668 0.297917 10.1857 0.25 10.3276 0.25C10.4694 0.25 10.5881 0.297917 10.6837 0.39375C10.7792 0.489583 10.8269 0.608333 10.8269 0.75V9.25H9.82692ZM6.15385 9.25V1.75C6.15385 1.60833 6.20183 1.48958 6.29778 1.39375C6.39374 1.29792 6.51266 1.25 6.65453 1.25C6.79638 1.25 6.91506 1.29792 7.01058 1.39375C7.10609 1.48958 7.15385 1.60833 7.15385 1.75V9.25H6.15385ZM10.0038 19.75C7.91666 19.75 6.14423 19.0221 4.68653 17.5662C3.22884 16.1103 2.5 14.3382 2.5 12.25V3.25C2.5 3.10833 2.54798 2.98958 2.64395 2.89375C2.7399 2.79792 2.85881 2.75 3.00067 2.75C3.14252 2.75 3.26121 2.79792 3.35672 2.89375C3.45224 2.98958 3.5 3.10833 3.5 3.25V12.25C3.5 14.0667 4.12917 15.6042 5.3875 16.8625C6.64583 18.1208 8.18333 18.75 10 18.75C11.8167 18.75 13.3542 18.1208 14.6125 16.8625C15.8708 15.6042 16.5 14.0667 16.5 12.25V8.25H16C15.5885 8.25 15.2356 8.39712 14.9413 8.69135C14.6471 8.98558 14.5 9.33847 14.5 9.75V12.6731H12.5769C11.8731 12.6731 11.2804 12.9138 10.799 13.3952L10.0981 12.6942C10.7788 12.0135 11.6051 11.6731 12.5769 11.6731H13.5V2.75C13.5 2.60833 13.548 2.48958 13.644 2.39375C13.7399 2.29792 13.8588 2.25 14.0007 2.25C14.1425 2.25 14.2612 2.29792 14.3567 2.39375C14.4522 2.48958 14.5 2.60833 14.5 2.75V7.8096C14.7051 7.6314 14.9335 7.49358 15.1852 7.39615C15.437 7.29872 15.7086 7.25 16 7.25H17.5V12.25C17.5 14.3382 16.7724 16.1103 15.3173 17.5662C13.8622 19.0221 12.091 19.75 10.0038 19.75Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 6",
    cx: 5,
    cy: 11,
    r: 1,
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 10,
    cy: 16,
    r: 1,
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 7",
    cx: 7.5,
    cy: 14.5,
    r: 0.5,
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 8",
    cx: 8.5,
    cy: 11.5,
    r: 0.5,
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 10",
    cx: 13.5,
    cy: 14.5,
    r: 0.5,
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllergicIcon);
export default __webpack_public_path__ + "static/media/allergicIcon.2835e3ec68db7efabfeedebedcc22c35.svg";
export { ForwardRef as ReactComponent };